import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GerinusService } from '../lib/gerinus.service';

@Injectable()
export class ProcessStatusService extends GerinusService {
    constructor(public http: HttpClient) {
        super(http);
        this.entityName = 'processo_status';
        this.model = 'ProcessStatusModel';
    }
}
